import { formatPrice } from "@lib/helpers";

const PricePerUnit = ({ price, unit, factor, hasPricePerFactor }) => {
  const { package_selling_price = null, selling_price = null } = price;
  const priceUnit = unit?.split("/")[1];

  if (hasPricePerFactor && package_selling_price) {
    return (
      <div className="text-[16px] text-[#71717B]">
        {package_selling_price} lei/buc
      </div>
    );
  }

  if (selling_price && factor && priceUnit) {
    return (
      <div className="mb-0.5">
        <small className="leading-none text-gray-1200 text-xs">
          {`${formatPrice(selling_price / parseFloat(factor))}`} lei/{priceUnit}
        </small>
      </div>
    );
  }

  return null;
};

export default PricePerUnit;
